import type { Action, Page } from 'modules/global/generic.types';
import createHasMoreReducer from 'modules/global/reducers/generic.hasMore';
import createPageReducer from 'modules/global/reducers/generic.page';
import * as types from 'modules/users/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export type SelectPageState = {
  page: Page;
  hasMore: boolean;
};

export type State = Record<string, SelectPageState>;

const page = createPageReducer(types.FETCH_USERS_REQUEST);
const hasMore = createHasMoreReducer(types.FETCH_USERS_REQUEST);

const initialState: State = {};

const handlePageUpdate = (state: State, action: Action): State => {
  const selectId = action.meta?.selectId as string;
  if (selectId) {
    const prevState = state[selectId] || { page: undefined, hasMore: false };
    const nextState: SelectPageState = {
      page: page(prevState.page, action),
      hasMore: hasMore(prevState.hasMore, action),
    };
    return { ...state, [selectId]: nextState };
  }
  return state;
};

export default createReducer(initialState, {
  [types.FETCH_USERS_REQUEST]: handlePageUpdate,
  [types.FETCH_USERS_SUCCESS]: handlePageUpdate,
  [types.FETCH_USERS_FAILURE]: handlePageUpdate,
});
